import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_ACCOUNT, UPDATE_CONTRIBUTION_AMT } from "../../../api/queryKeys";
import { APIStandardError, SponsoredSavings } from "../../../types";

export default function useUpdateContribution() {
  const queryClient = useQueryClient();
  return useMutation<
    SponsoredSavings["ssp_enrollment"],
    AxiosError<APIStandardError>,
    {
      programEnrollmentId: number;
      contribution: string;
      directDepositUserAgreed: boolean;
    }
  >(
    ({ programEnrollmentId, contribution, directDepositUserAgreed }) =>
      api
        .patch(`${UPDATE_CONTRIBUTION_AMT}/${programEnrollmentId}/`, {
          ssp_ygbm_monthly_contribution: contribution,
          sponsored_savings_autoswitch_directdeposit_user_agreed:
            directDepositUserAgreed,
        })
        .then((res) => res.data),
    {
      onError: (error) => {
        toast.error("Unable to update contribution");
      },
      onSuccess: () => {
        queryClient.refetchQueries([QUERY_ACCOUNT]);
      },
    }
  );
}
